<!--
 * @Description: xuzhongqi
 * @Version: 1.0
 * @Autor: xuzhongqi
 * @Date: 2022-01-07
 * @LastEditors: lt
 * @LastEditTime: 2022-07-13 15:17:43
-->
<template>
  <div>

    <el-row
      :gutter="20"
      class="search"
    >
      <el-col :span="searchStyleTypes === '' ? 15 : searchStyleTypes === 'gift' ? 18 : 18">
        <div class="search-menu" :class="{'menu-seckill-active': searchStyleTypes !== '' }">
          <span
            :class="{'menu-active': SortType === 0 }"
            @click="handleMenu(0)"
          >
            综合排序
            <img
              :src="SortType === 0 ? require('../../../assets/menu1-active.png') : require('../../../assets/menu1.png')"
              fit="cover"
            >
          </span>
          <span
            :class="{'menu-active': SortType === 1 && IsSortAsc !== '' }"
            @click="handleMenu(1)"
          >
            价格排序
            <img
              :src="IsSortAsc === '' ? require('../../../assets/menu2.png') : IsSortAsc ? require('../../../assets/menu2-active-right.png') : require('../../../assets/menu2-active-left.png')"
              fit="cover"
            >
          </span>
          <span
            class="menu-box"
            :class="{'menu-active': menusOneValue !== '' || menusOneValue !== '' }"
            @click="handleMenuClass"
          >
            分类筛选
            <img
              :src="(menusOneValue !== '' || menusOneValue !== '') ? require('../../../assets/menu3-active.png') : require('../../../assets/menu3.png')"
              fit="cover"
            >
          </span>
        </div>
      </el-col>
      <el-col :span="searchStyleTypes === '' ? 9 : searchStyleTypes === 'gift' ? 6 : 6">
        <div class="search-input-view">
          <el-row>
            <el-col :span="21">
              <div>
                <el-input
                  v-model="Keyword"
                  clearable
                  class="search-input"
                  placeholder="搜索专区内商品"
                  size="mini"
                />
              </div>
            </el-col>
            <el-col :span="3">
              <div
                class="search-bottom-view"
                @click="search"
              >
                <img
                  src="../../../assets/search-icon.png"
                  fit="cover"
                  class="search-icon"
                >
              </div>
            </el-col>
          </el-row>
        </div>
      </el-col>
    </el-row>

    <!-- 分类筛选隐藏菜单 -->
    <div
      class="menu-class"
      :class="{ 'fixed-menu-view' : isFixedMenus, 'menu-class-border-none' : !isMenusOne }"
    >
      <div
        v-show="isMenusOne"
        class="menu-list"
      >
        <el-row>
          <el-col :span="2">
            <label>一级分类</label>
          </el-col>
          <el-col :span="22">
            <span
              :class="{ 'menu-active' : menusOneValue === ''}"
              @click="menuClick('one', '')"
            >全部分类</span>
            <span
              v-for="(item, index) in menusOneData"
              :key="index"
              :class="{ 'menu-active' : menusOneValue === item.Id}"
              @click="menuClick(1, item)"
            >{{ item.Name }}</span>
          </el-col>
        </el-row>
      </div>
      <div
        v-show="isMenusTwo"
        class="menu-list"
      >
        <el-row>
          <el-col :span="2">
            <label>二级分类</label>
          </el-col>
          <el-col :span="22">
            <span
              :class="{ 'menu-active' : menusTwoValue === ''}"
              @click="menuClick('two', '')"
            >全部分类</span>
            <span
              v-for="(item, index) in menusTwoData"
              :key="index"
              :class="{ 'menu-active' : menusTwoValue === item.Id}"
              @click="menuClick(2, item)"
            >{{ item.Name }}</span>
          </el-col>
        </el-row>
      </div>
    </div>
    <!-- 分类筛选隐藏菜单 end -->

  </div>
</template>

<script>
export default {
  components: {},
  props: {
    // 监听父组件传递的fixed标记对象
    isFixedMenu: {
      type: Boolean,
      default: () => false
    },
    searchStyleType: {
      type: String,
      default: () => ''
    }
  },
  data() {
    return {
      // 模糊查询关键字
      Keyword: '',
      // 排序类型 0综合排序 1价格 2销量 3分类（3仅是前端使用，接口用不到）
      SortType: 0,
      // 排序模式，是否正序，如果选择综合排序，则该参数会传空
      IsSortAsc: '',
      // 分类ID
      ClassId: '',
      // 搜索menu是否需要固定标记,默认false
      isFixedMenus: false,
      // 分类菜单隐藏，展示标记(一级)
      isMenusOne: false,
      // 分类菜单隐藏，展示标记(二级)
      isMenusTwo: false,
      // 一级分类点击存值
      menusOneValue: '',
      // 二级分类点击存值
      menusTwoValue: '',
      // 一级分类遍历集合
      menusOneData: [],
      // 二级分类遍历集合
      menusTwoData: [],
      // 搜索组件样式类型, 传gift代表满赠/换购，传空代表其余的活动板块
      searchStyleTypes: ''
    }
  },
  computed: {},
  watch: {
    isFixedMenu: {
      handler(newVal) {
        // 覆盖本地行数据对象
        this.isFixedMenus = newVal
      },
      deep: true, // true 深度监听
      immediate: true // 第一次绑定是否执行
    },
    searchStyleType: {
      handler(newVal) {
        // 覆盖本地行数据对象
        this.searchStyleTypes = newVal
      },
      deep: true, // true 深度监听
      immediate: true // 第一次绑定是否执行
    }
  },
  created() {
    // 初始化获取所有分类
    this.getActivityClassification()
  },
  methods: {
    /*
     * 获取所有分类
     */
    async getActivityClassification() {
      // 获取分类
      const res = await this.getAction(
        'api_promotions/PromotionActivities/GetActivityClassification'
      )
      if (!res.IsSuccess) {
        this.$toast.fail(res.Msg)
        return
      }
      if (res.IsSuccess && res.Data.length === 0) {
        this.$toast.fail('暂无分类数据')
        return
      }
      // 请求成功
      this.menusOneData = res.Data
    },
    /*
     * 搜索触发
     */
    search() {
      const params = {
        Keyword: this.Keyword,
        SortType: this.SortType,
        IsSortAsc: this.SortType === 0 ? true : this.IsSortAsc,
        ClassId:
          this.menusTwoValue !== ''
            ? this.menusTwoValue
            : this.menusOneValue !== ''
              ? this.menusOneValue
              : ''
      }
      this.$emit('on-trigge', params)
    },
    /*
     * 综合排序，价格排序监听
     * @param e {number} 每次点击的类型
     */
    handleMenu(e) {
      if (e === 0) {
        // 综合排序
        // 重置所有查询条件
        this.SortType = 0
        this.IsSortAsc = ''
        // this.ClassId = ''
        // this.menusOneValue = ''
        // this.menusTwoValue = ''
        // this.menusTwoData = ''
      } else if (e === 1) {
        // 价格排序
        // 更改查询条件
        this.SortType = 1
        this.IsSortAsc === ''
          ? (this.IsSortAsc = true)
          : this.IsSortAsc
            ? (this.IsSortAsc = false)
            : (this.IsSortAsc = true)
      }
      // 初始化分类元素隐藏条件
      this.closeMenus()

      // 向父组件派发请求获取list
      this.search()
    },
    /*
     * 分类筛选按钮点击
     */
    handleMenuClass() {
      if (this.isMenusOne) {
        // 初始化分类元素隐藏条件
        this.closeMenus()
      } else {
        // 开起一级菜单
        this.isMenusOne = true
        // 判断是否需要第一次就开起二级
        this.menusTwoData.length === 0
          ? (this.isMenusTwo = false)
          : (this.isMenusTwo = true)
      }
    },
    /*
     * 分类点击
     * @param type {number} 每次点击的层级类型，1 一级， 2 二级
     * @param item {object} 每次点击的分类对象
     */
    menuClick(type, item) {
      if (type === 1) {
        // 保存第一级Id
        this.menusOneValue = item.Id
        // 点击第一级，判断是否需要获取并展示第二级
        if (item.Condition === null) {
          // 清空第二级Id
          this.menusTwoValue = ''
          this.menusTwoData = []
          // 初始化分类元素隐藏条件
          this.closeMenus()
        } else {
          // 获取对应第二级的数据集合
          this.menusTwoData = item.Condition
          this.menusTwoValue = ''
          // 开起对应二级菜单
          this.isMenusTwo = true
        }
      } else if (type === 2) {
        // 保存第二级Id
        this.menusTwoValue = item.Id
        // 初始化分类元素隐藏条件
        this.closeMenus()
      } else if (type === 'one' && item === '') {
        // 一级分类点击全部
        this.menusOneValue = ''
        // 清空二级分类
        this.menusTwoValue = ''
        this.menusTwoData = []
        // 初始化分类元素隐藏条件
        this.closeMenus()
      } else if (type === 'two' && item === '') {
        // 一级分类点击全部
        this.menusTwoValue = ''
        // 初始化分类元素隐藏条件
        this.closeMenus()
      }
      // 向父组件派发请求获取list
      this.search()
    },
    /*
     * 初始化分类元素隐藏条件
     */
    closeMenus() {
      this.isMenusOne = false
      this.isMenusTwo = false
    }
  }
}
</script>

<style lang="less" scoped>
@import url("~@/styles/activityView.less");
</style>
